import { css, cx } from "@emotion/css";
import { MinusIcon, CheckIcon } from "@octopusdeploy/design-system-icons";
import { themeTokens, borderWidth, borderRadius } from "@octopusdeploy/design-system-tokens";
interface MultiSelectCheckboxProps {
    checked: boolean;
    isDisabled?: boolean;
    isIndeterminate?: boolean;
}
export function MultiSelectCheckbox({ checked, isDisabled, isIndeterminate }: MultiSelectCheckboxProps) {
    return (<div className={cx(checkboxStyles.container, { [checkboxStyles.checked]: checked, [checkboxStyles.disabled]: isDisabled })}>
            {isIndeterminate ? <MinusIcon size={16} color="currentColor"/> : checked ? <CheckIcon size={16} color="currentColor"/> : undefined}
        </div>);
}
const checkboxButtonSize = "1.25rem";
export const checkboxStyles = {
    container: css({
        display: "grid",
        placeContent: "center",
        boxSizing: "border-box",
        backgroundColor: themeTokens.color.background.primary.default,
        border: `${borderWidth[1]} solid ${themeTokens.color.border.bold}`,
        borderRadius: borderRadius.extraSmall,
        width: checkboxButtonSize,
        height: checkboxButtonSize,
        color: themeTokens.color.icon.inverse.primary,
    }),
    checked: css({
        border: "none",
        backgroundColor: themeTokens.color.background.selected,
    }),
    disabled: css({
        color: themeTokens.color.icon.tertiary,
        backgroundColor: themeTokens.color.background.disabled,
    }),
};
